import { graphql } from "relay-runtime"

const SocialHistoryFragment = graphql`
  fragment SocialHistoryFragment on SocialHistory {
    id
    comment
    drinkingHabit
    smokingHabit
  }
`

export { SocialHistoryFragment }
